export default __webpack_public_path__ + "static/media/Green.5ef6e002.svg";